module.exports = __webpack_public_path__ + "img/hero.ee77baea.jpg";